import React from "react";
import { FaFacebook, FaWhatsapp, FaInstagram } from "react-icons/fa";

const SocialIcons = () => {
  return (
    <div className="flex items-center gap-4 bg-black/5 py-1 px-3 rounded-md w-fit">
      {/* Facebook */}
      <a
        href="https://www.facebook.com/profile.php?id=61583101236482"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        className="text-[#1877F2] text-3xl hover:scale-110 hover:opacity-80 transition-transform duration-200"
      >
        <FaFacebook />
      </a>

      {/* WhatsApp */}
      <a
        href="https://wa.me/yourphonenumber"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="text-[#25D366] text-3xl hover:scale-110 hover:opacity-80 transition-transform duration-200"
      >
        <FaWhatsapp />
      </a>

      {/* Instagram */}
      <a
        href="https://instagram.com/yourprofile"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className="text-[#E4405F] text-3xl hover:scale-110 hover:opacity-80 transition-transform duration-200"
      >
        <FaInstagram />
      </a>
    </div>
  );
};

export default SocialIcons;
